export const GROWTH_STATES = ["seedling", "budding", "evergreen"];
